<template>
  <layout>
    <div v-if="!covidPositive && !covidNegative" style="padding: 10px">
      <div class="covid-title-text">
        {{ covidTexts.covid_title }}
      </div>
      <div class="covid-symptoms-question">
        {{ covidTexts.covid_question }}
      </div>
      <div class="covid-button-container">
        <div class="covid-button covid-negative" @click="proceedToLoginOptions()">
          <span>{{ $t('generic.no') }}</span>
        </div>
        <div class="covid-button covid-positive" @click="notAllowToEnterLocation()">
          <span>{{ $t('generic.yes') }}</span>
        </div>
      </div>
    </div>

    <div v-if="covidNegative" style="padding: 10px">
      <div class="covid-negative-title-text">
        {{ covidTexts.covid_success }}
      </div>
      <p class="redirect-time">{{ timer / 1000 }} s</p>
    </div>

    <div v-if="covidPositive" style="padding: 10px">
      <div class="covid-positive-title-text">
        {{ covidTexts.covid_error }}
      </div>
    </div>
  </layout>
</template>

<script>
  import Layout from './layout'
  import { logUserAction } from '../utils/logging'
  import screens from '../utils/pageSchema'

  export default {
    components: {
      Layout,
    },
    data() {
      return {
        timer: '5000',
        covidForm: false,
        covidPositive: false,
        covidNegative: false,
      }
    },
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      covidTexts() {
        return this.baseData.i18n[this.$i18n.locale]
      },
    },
    methods: {
      proceedToLoginOptions() {
        logUserAction({
          type: 'user_action',
          label: 'User Reported No COVID Symptoms',
        })
        this.covidNegative = true
        window.setInterval(() => {
          if (this.timer !== 0) {
            this.$set(this, 'timer', this.timer - 1000)
          }
        }, 1000)
        setTimeout(async () => {
          this.covidNegative = false
          logUserAction({
            type: 'navigation',
            label: 'Redirecting to Payment Plans Page',
          })
          await screens.advance()
        }, 5000)
      },
      notAllowToEnterLocation() {
        logUserAction({
          type: 'user_action',
          label: 'User Reported COVID Symptoms',
        })
        this.covidPositive = true
        this.covidNegative = false
      },
    },
  }
</script>

<style scoped>
  .redirect-time {
    font-size: 12px;
    background: #f4f4f4;
    display: inline-block;
    padding: 10px 20px;
    border-radius: 32px;
    font-weight: 600;
    color: #808080;
    margin-right: 10px;
  }

  .covid-title-text {
    font-weight: bold;
    margin-bottom: 15px;
    white-space: break-spaces;
    word-wrap: break-word;
  }

  .covid-negative-title-text {
    font-weight: bold;
    color: #4bb543;
    opacity: 0.6;
  }

  .covid-positive-title-text {
    font-weight: bold;
    color: #ff3333;
    opacity: 0.6;
  }

  .covid-symptoms-question {
    font-size: 15px;
    margin-bottom: 15px;
    white-space: break-spaces;
    word-wrap: break-word;
  }

  .covid-button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .covid-button {
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 400;
    width: 100px;
    color: white;
    margin-top: 10px;
    border-radius: 25px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .covid-button:hover {
    cursor: pointer;
  }

  .covid-negative {
    background: #4bb543;
    white-space: break-spaces;
    word-wrap: break-word;
  }

  .covid-positive {
    background: #ff3333;
    white-space: break-spaces;
    word-wrap: break-word;
  }
</style>
